import React, { useEffect, useState } from 'react';
import {
  Form,
  FormItem,
  SubmitButton,
  Button,
  Dropdown,
  AutoComplete,
} from '../../components';
import { type ModelType, modelTypesOptions } from './const';
import type { AiModelData } from '../../api';

export type ModelFormProps = {
  modelType: ModelType | string;
  modelId: string;
};

type DeleteModelFormProps = {
  saving: boolean;
  onCancel: () => void;
  onSave: (id: string, type: ModelType) => void;
  allModels: Record<ModelType, AiModelData[] | null>;
};

const CreateModelForm: React.FC<DeleteModelFormProps> = ({
  saving,
  onSave,
  allModels,
  onCancel,
}) => {
  const [values, setFormValues] = useState<ModelFormProps | null>(null);
  const [currentModels, setCurrentModels] = useState<any[]>([]);
  const [modelId, setModelId] = useState<string>('');

  useEffect(() => {
    if (!values?.modelType) return;

    const modelType = values.modelType as ModelType;
    const selectedModels = allModels?.[modelType] ?? [];

    const mappedModels = selectedModels.map((d: AiModelData) => ({
      ...d,
      value: d.id,
      label: d.label ?? '',
    }));

    setCurrentModels(mappedModels);
  }, [values?.modelType, allModels]);

  useEffect(() => {
    if (values?.modelId) {
      setModelId(values.modelId);
    }
  }, [values, values?.modelId]);

  return (
    <div className="flex flex-col gap-y-12 w-full">
      <Form onChange={setFormValues} initialValue={values as ModelFormProps}>
        <FormItem<ModelFormProps>
          required
          name="modelType"
          label="Model Type"
          inline={false}
        >
          <Dropdown
            placeholder="Select Model Type"
            options={modelTypesOptions}
          />
        </FormItem>
        <FormItem<ModelFormProps>
          required
          name="modelId"
          label="Model Name"
          inline={false}
        >
          <AutoComplete placeholder="Select Model" options={currentModels} />
        </FormItem>

        <div className="flex flex-col gap-y-md justify-center items-center">
          <SubmitButton
            size="large"
            disabled={saving}
            className="w-full"
            label="Delete Model"
            onClick={() => onSave(modelId, values?.modelType as ModelType)}
          />
          <Button
            size="large"
            type="contrast"
            label="Cancel"
            className="w-full text-main"
            onClick={onCancel}
          />
        </div>
      </Form>
    </div>
  );
};

export default CreateModelForm;
